import React, { useState } from 'react'
import className from 'classnames/bind'

import style from './MyhouseReviewDetailTitle.module.scss'

import SvgMyhouseDetailButtonMenu from '@Ui/images/myhouse/myhouse_detail_button--menu.svg'
import SvgMyhouseDetailProfileNone from '@Ui/images/myhouse/myhouse_detail_profile--none.svg'
import MyhouseContextMenu from '@Components/atoms/MyhouseContextMenu'
import { MY_HOUSE_BOARD_TYPE } from '@Root/contants/myhouse'
import useBoard from '@Hooks/myhouse/board/useBoard'
import useReview from '@Hooks/myhouse/review/useReview'

const cx = className.bind(style)

type Props = {
  isOpened: boolean
  setIsOpened: (isOpened: boolean) => void
}

const MyhouseReviewDetailTitle: React.FC<Props> = ({ isOpened, setIsOpened }: Props) => {
  const { review } = useReview()
  const detail = review?.detail

  const { readCount, modifiedDate, isWriter, buildingName, userNickName, profileImageUrl } = detail

  const { getFormattedDate } = useBoard()

  const toggleMenu = (evt: React.SyntheticEvent) => {
    evt.preventDefault()
    evt.stopPropagation()

    setIsOpened(!isOpened)
  }

  return (
    <div className={cx('myhouse_detail_title')}>
      <div className={cx('myhouse_write_info')}>
        <div style={{ backgroundImage: `url(${profileImageUrl})` }} className={cx('myhouse_image_thumbnail')}>
          {!profileImageUrl && <SvgMyhouseDetailProfileNone />}
        </div>
        <div className={cx('myhouse_info_detail')}>
          <span className={cx('myhouse_info_writer')}>
            {userNickName}
            {!!buildingName && <em className={cx('myhouse_info_building')}>{` (${buildingName}동)`}</em>}
          </span>
          <span className={cx('myhouse_info_time')}>{getFormattedDate(modifiedDate)}</span>
          <span className={cx('myhouse_info_view')}>{`조회 ${readCount}`}</span>
        </div>
      </div>
      <button type="button" className={cx('myhouse_button_menu')} aria-label="메뉴" onClick={toggleMenu}>
        <SvgMyhouseDetailButtonMenu />
      </button>
      {isOpened && <MyhouseContextMenu isWriter={isWriter} boardType={MY_HOUSE_BOARD_TYPE.REVIEW} />}
    </div>
  )
}

export default MyhouseReviewDetailTitle
